import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/Store";
import { OrderTimeline } from "../components/OrderTimeline";

const badge = { paid: "bg-[#1E5E3A] text-white", pending: "bg-[#D99B26] text-[#1A1714]", failed: "bg-red-600 text-white" };

export default function Orders() {
  const { user, authChecked, fmt } = useStore();
  const [orders, setOrders] = useState(null);
  const [sp] = useSearchParams();
  const nav = useNavigate();
  useEffect(() => {
    if (!authChecked) return;
    if (!user) { nav("/login", { state: { next: "/orders" } }); return; }
    api.get("/orders/mine").then((r) => setOrders(r.data));
  }, [authChecked, user, nav]);
  return (
    <div className="max-w-4xl mx-auto px-6 py-10" data-testid="orders-page">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold">My orders</h1>
      {orders === null ? <div className="h-40 mt-8 rounded-2xl bg-stone-200 animate-pulse" /> : orders.length === 0 ? (
        <p className="mt-10 text-stone-500" data-testid="orders-empty">No orders yet. <Link to="/shop" className="text-[#C85A32] font-semibold">Start shopping</Link></p>
      ) : (
        <div className="space-y-4 mt-8">
          {orders.map((o) => (
            <div key={o.order_id} data-testid={`order-${o.order_id}`} className={`bg-white rounded-2xl p-5 border-2 ${sp.get("highlight") === o.order_id ? "border-[#C85A32]" : "border-transparent"}`}>
              <div className="flex flex-wrap justify-between gap-2 items-center">
                <div><p className="font-display font-bold">{o.order_id}</p><p className="text-xs text-stone-500">{new Date(o.created_at).toLocaleString()} · {o.method.toUpperCase()}{o.simulated ? " (demo)" : ""}</p></div>
                <span data-testid={`order-status-${o.order_id}`} className={`text-xs font-bold uppercase px-3 py-1 rounded-full ${badge[o.payment_status] || badge.pending}`}>{o.payment_status}</span>
              </div>
              <div className="flex gap-2 mt-4 overflow-x-auto">{o.items.map((i) => <Link key={i.product_id} to={`/product/${i.product_id}`} data-testid={`order-item-link-${i.product_id}`}><img src={i.image} alt="" title={o.payment_status === "paid" ? "Review this item" : i.title} className="w-14 h-14 rounded-lg object-cover hover:ring-2 hover:ring-[#C85A32] transition-shadow" /></Link>)}</div>
              {o.payment_status === "paid" && <p className="text-xs text-stone-500 mt-2">Tap an item to leave a review</p>}
              <OrderTimeline order={o} />
              <p className="mt-3 font-semibold text-right">Total {fmt(o.total_usd)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
